<template>
  <div
    v-if="isShowComponent"
    class="datasheet-button-container"
  >
    <a
      class="datasheet-button text-muted"
      :href="parsedUrl"
      target="_blank"
    >
      <i
        class="fa fa-file-pdf-o"
        aria-hidden="true"
      />
      <span>{{ $translate("EnergyLabel::Template.energyLabelDatasheet") }}</span>
    </a>
  </div>
</template>

<script>
import { elParseTemplatedExpression } from '../helper/parser';

export default {

  inject: {
    itemId: {
      default: null
    }
  },
  props: {
    itemData: [String, Object],
    itemDataObj: { type: Object },
    freeFields: [Object],
    variationId: {
      type: Number,
      default: 0
    }
  },

  computed: {
    computedItemData () {
      if (this.itemData === 'categoryItem') {
        if (this.$parent && this.$parent.item) {
          return { ...this.$parent.item, ...{ freeFields: this.freeFields } };
        }

        if (this.itemDataObj && this.itemDataObj.item && this.itemDataObj.item.id) {
          return { ...this.itemDataObj, ...{ freeFields: this.freeFields } };
        }

        if (this.variationId) {
          const lastSeenItem = this.$store.state.lastSeen.lastSeenItems.find(itemDat => itemDat.id === this.variationId);
          return lastSeenItem ? { ...lastSeenItem.data, ...{ freeFields: this.freeFields } } : {};
        }
      } else if (this.itemData === 'basketItem') {
        if (this.$parent && this.$parent.basketItem) {
          const variationData = JSON.parse(JSON.stringify(this.$parent.basketItem.variation.data));
          variationData.variationProperties = variationData.fullVariationProperties;

          if (EnergyLabelConfig.basketFreeFields.length > 0) {
            const freeF = EnergyLabelConfig.basketFreeFields.find(itemDat => itemDat.id === variationData.item.id);
            return { ...variationData, ...{ freeFields: freeF } };
          } else {
            return variationData;
          }
        }
      } else if (this.itemData === 'singleItem') {
        return this.$store.getters[`${this.itemId}/currentItemVariation`];
      }
      return this.itemData;
    },

    isUseLowercase () {
      if (EnergyLabelConfig.global.useLowercase === true || EnergyLabelConfig.global.useLowercase == 'true') {
        return true;
      }
      return false;
    },

    parsedUrl () {
      const datasheetUrl = EnergyLabelConfig.global.datasheet ? EnergyLabelConfig.global.datasheet : '';

      return this.parseTemplatedExpression(datasheetUrl, true);
    },

    isShowComponent () {
      return this.parsedUrl && this.parsedUrl.length > 0;
    }
  },

  methods: {
    parseTemplatedExpression (text, emptyWipe = false) {
      return elParseTemplatedExpression(text, this.computedItemData, this.isUseLowercase, emptyWipe);
    }
  }

};
</script>
